import React, { useState, useEffect } from "react"
import { useApolloClient } from "@apollo/client"
import StaticMultiSelector from "../Atoms/StaticMultiSelector"
import getList from "utils/get-list"
import { debounce } from "lodash-es"

const useQuery = (query, variables) => {
  const client = useApolloClient()
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    ;(async () => {
      const { data, loading, error } = await client.query({
        query,
        variables,
      })
      setData(data)
      setLoading(loading)
      setError(error)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variables])

  return { data, loading, error }
}

const LazyMultiSelector = ({
  query,
  variables = undefined,
  renderText = undefined,
  renderLabel = undefined,
  renderTag = undefined,
  ...staticSelectorProps
}) => {
  const [searchQuery, setSearchQuery] = useState("")
  const { data, loading } = useQuery(query, {
    query: searchQuery,
    first: 10,
  })

  function handleChange(srch) {
    if (srch !== searchQuery) setSearchQuery(srch)
  }
  const debouncedChange = debounce(handleChange, 500)

  let list = []
  if (data) {
    list = getList(data)
  }

  return (
    <StaticMultiSelector
      loading={loading}
      items={list}
      renderText={renderText}
      renderTag={renderTag}
      renderLabel={renderLabel}
      search={searchQuery}
      onSearchChange={debouncedChange}
      {...staticSelectorProps}
    />
  )
}

export default LazyMultiSelector
